import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { InsurancePolicy } from '@/types/insurance';

type CreateInsurancePolicyData = Omit<InsurancePolicy, 'id' | 'user_id' | 'created_at' | 'updated_at'>;

export function useCreateInsurancePolicy() {
  const qc = useQueryClient();
  const { user } = useAuth();

  return useMutation({
    mutationFn: async (policy: CreateInsurancePolicyData) => {
      const { data, error } = await supabase
        .from('insurance_policies')
        .insert({ ...policy, user_id: user!.id })
        .select()
        .single();
      if (error) throw error;
      return data as InsurancePolicy;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['insurance-policies'] });
    },
  });
}
